export default __webpack_public_path__ + "static/media/search.31033a52.svg";